import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import classes from './MultiSelect.module.css';

export const MultiSelectOverrideClassnames = (props: InputStyleProps) => {
  const { size, checkIconPosition } = props;

  const inputClasses = InputOverrideClassNames(props);

  return {
    ...inputClasses,
    label: inputClasses.label,
    wrapper: classes.wrapper,
    dropdown: classes.dropdown,
    input: cx(inputClasses.input, classes.input, {
      [classes.inputXs]: size === 'xs',
      [classes.inputSm]: size === 'sm',
      [classes.inputMd]: size === 'md',
      [classes.inputLg]: size === 'lg',
      [classes.inputXl]: size === 'xl'
    }),
    inputField: classes.inputField,
    options: classes.options,
    option: classes.option,
    tickRight: cx({ [classes.tickRight]: checkIconPosition === 'right' }),
    pill: cx(classes.pill, {
      [classes.pillXs]: size === 'xs',
      [classes.pillSm]: size === 'sm',
      [classes.pillMd]: size === 'md',
      [classes.pillLg]: size === 'lg',
      [classes.pillXl]: size === 'xl'
    }),
    pillsList: classes.pillsList,
    remove: cx({
      [classes.removeSmall]: size === 'xs' || size === 'sm',
      [classes.removeBig]: size === 'md' || size === 'lg' || size === 'xl'
    }),
    section: cx({
      [classes.sectionXs]: size === 'xs',
      [classes.sectionSm]: size === 'sm',
      [classes.sectionMd]: size === 'md',
      [classes.sectionLg]: size === 'lg',
      [classes.sectionXl]: size === 'xl'
    }),
    icon: classes.icon
  };
};
